export const SEND_MESSAGE_SOURCE = 'listing_page_contact';
